import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const ThemeContext = createContext({ theme: "dark", toggle: () => {}, setTheme: () => {} });

const storageKey = (role) => `df_theme_${role || "guest"}`;

// Portal content theme. "light" / "dark" applies ONLY to the dashboard content
// area (the page background + cards + fields) — the sidebar and top bar are
// always dark. The layouts read this and add `theme-light` to their <main>.
// Preference persists per device, keyed by the signed-in role so switching
// between an admin and a client account on the same browser never leaks one
// portal's appearance into the other.
export function ThemeProvider({ children }) {
  const { user } = useAuth();
  const role = user?.role || "guest";
  const [theme, setThemeState] = useState(() => localStorage.getItem(storageKey(role)) || "dark");

  // Re-read the stored preference whenever the signed-in role changes.
  useEffect(() => {
    setThemeState(localStorage.getItem(storageKey(role)) || "dark");
  }, [role]);

  useEffect(() => {
    localStorage.setItem(storageKey(role), theme);
  }, [theme, role]);

  const toggle = () => setThemeState((t) => (t === "dark" ? "light" : "dark"));
  return (
    <ThemeContext.Provider value={{ theme, toggle, setTheme: setThemeState }}>{children}</ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
